import { DataGrid } from '@mui/x-data-grid'
import useAdminLeaveRequestsJapanPageViewModel from './viewModel'
import AdminMainContainer from '../../../../layouts/admin/AdminMainContainer'
import { Alert, Box, Button } from '@mui/material'
import constants from '../../../../constants'
import RefreshIcon from '@mui/icons-material/Refresh'

export default function AdminLeaveRequestsJapanPage() {
  const viewModel = useAdminLeaveRequestsJapanPageViewModel()

  return (
    <AdminMainContainer title='Leave Requests (Japan Team)'>
      <Alert
        severity='info'
        sx={{ mb: 2 }}
        action={
          <Button
            color='inherit'
            size='small'
            startIcon={<RefreshIcon />}
            onClick={() => viewModel.fetchLeaveRequestsRespondedData()}
          >
            Refresh
          </Button>
        }
      >{`This page only showing latest ${constants.limits.fetchDataCount.md} data.`}</Alert>

      <Box sx={{ maxWidth: '100%' }}>
        <DataGrid
          showToolbar
          density='compact'
          columns={viewModel.tableData.columns}
          rows={viewModel.tableData.rows}
          loading={viewModel.dataFetchStatus.isLoading}
        />
      </Box>
    </AdminMainContainer>
  )
}
